interface TableData {
  head: React.ReactNode[];
  body: React.ReactNode[][];
}

type Props = {
  tabledata: TableData;
  onRowClick?: (rowIndex: number) => void;
  columnWidths?: string[];
  isPaddingRightEnabled?: boolean;
};

const Table: React.FC<Props> = ({
  tabledata,
  onRowClick,
  columnWidths,
  isPaddingRightEnabled = true,
}) => {
  return (
    <div className="rounded-[0.5rem] overflow-x-scroll border border-1 border-separate border-[#d9d9d9]">
      <div
        className={`w-full ${!columnWidths || columnWidths?.length === 0 ? "min-w-[1000px]" : ""}`}
        style={{
          minWidth: `${columnWidths && columnWidths?.length > 0 && isPaddingRightEnabled ? `calc(${[...columnWidths, "1.25rem"].join(" + ")})` : null}`,
        }}
      >
        <div
          className="h-min / bg-white"
          style={{
            minWidth: `${columnWidths && columnWidths?.length > 0 && isPaddingRightEnabled ? `calc(${[...columnWidths, "5px"].join(" + ")})` : null}`,
          }}
        >
          <table className="w-full table-fixed">
            <thead
              className={`${
                tabledata.body.length > 0 ? "border-b" : ""
              } border-[#d9d9d9]`}
            >
              <tr>
                {tabledata.head.map((item, index) => {
                  const widthStyle = columnWidths?.[index]
                    ? { width: columnWidths[index] }
                    : {};
                  if (index === 0) {
                    return (
                      <th
                        key={index}
                        style={widthStyle}
                        className={`text-left / py-[0.7188rem] / px-[1.125rem] / bg-[#F8F8F8] rounded-tl-[0.5rem] ${
                          tabledata.body.length === 0
                            ? "rounded-bl-[0.5rem]"
                            : ""
                        }`}
                      >
                        {item}
                      </th>
                    );
                  } else if (index === tabledata.head.length - 1) {
                    return (
                      <th
                        key={index}
                        style={widthStyle}
                        className={`text-left / py-[0.7188rem] / px-[1.125rem] / bg-[#F8F8F8] rounded-tr-[0.5rem] ${
                          tabledata.body.length === 0
                            ? "rounded-br-[0.5rem]"
                            : ""
                        }`}
                      >
                        {item}
                      </th>
                    );
                  } else {
                    return (
                      <th
                        key={index}
                        style={widthStyle}
                        className=" text-left / py-[0.7188rem] / px-[1.125rem] / bg-[#F8F8F8]"
                      >
                        {item}
                      </th>
                    );
                  }
                })}
              </tr>
            </thead>
            <tbody>
              {tabledata.body.map((item1, i) => {
                const widthStyle = columnWidths?.[i]
                  ? { width: columnWidths[i] }
                  : {};
                return (
                  <tr
                    key={i}
                    style={widthStyle}
                    onClick={() => onRowClick?.(i)}
                    className={`${
                      i !== tabledata.body.length - 1
                        ? "border-b border-[#d9d9d9]"
                        : ""
                    } group ${onRowClick ? "cursor-pointer" : ""}`}
                  >
                    {item1.map((item2, j) => {
                      const widthStyle = columnWidths?.[j]
                        ? { width: columnWidths[j] }
                        : {};
                      return (
                        <td
                          key={j}
                          style={widthStyle}
                          className={`
                         ${
                           j === 0 && i === tabledata.body.length - 1
                             ? "rounded-bl-[0.5rem]"
                             : ""
                         }
                          ${
                            j === item1.length - 1 &&
                            i === tabledata.body.length - 1
                              ? "rounded-b-[0.5rem]"
                              : ""
                          }
                       text-left / py-[0.7188rem] / px-[1.125rem]
                       / transition-colors group-hover:bg-[#F2F2F2] break-words`}
                        >
                          {item2}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Table;
